import { createSelector } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import * as visibilityReducer from './visibility.reducer';

/**
 * Reducer state selector
 */
export const getState = (state: {
    visibility: visibilityReducer.State;
}): visibilityReducer.State => state.visibility;

export const getVisibilityForIdStatus = (entityType: SystemEntity, entityId: string) =>  createSelector(
    getState,
    (
        state: visibilityReducer.State,
    ) => state.visibility?.[entityType]?.[entityId]?.status,
);

export const getVisibilityForId = (entityType: SystemEntity, entityId: string) =>  createSelector(
    getState,
    (
        state: visibilityReducer.State,
    ) => state.visibility?.[entityType]?.[entityId]?.record,
);
